<template>
    <base-dialog :value="dialog" :title="$t('business.booking_type_title')" :width="380" @input="onInput" @close="hide">
        <span v-if="subtitle" class="booking-type-sub">{{ subtitle }}</span>

        <button type="button" class="booking-type-option" @click="select(false)">
            <span class="booking-type-name">{{ $t('business.booking_once') }}</span>
            <span class="booking-type-desc">{{ $t('business.booking_once_desc') }}</span>
        </button>

        <button type="button" class="booking-type-option" @click="select(true)">
            <span class="booking-type-name">{{ $t('business.booking_fixed') }}</span>
            <span class="booking-type-desc">{{ $t('business.booking_fixed_desc') }}</span>
        </button>
    </base-dialog>
</template>

<script>
import BaseDialog from "@/components/common/BaseDialog";

export default {
    name: "BookingTypeDialog",
    components: { BaseDialog },
    props: {
        subtitle: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            dialog: false,
        }
    },
    methods: {
        show() {
            this.dialog = true
        },
        hide() {
            this.dialog = false
        },
        onInput(value) {
            if (!value) this.hide()
        },
        select(fixed) {
            const vm = this
            vm.hide()
            vm.$emit('select', fixed)
        },
    },
}
</script>

<style scoped>
.booking-type-sub {
    display: block;
    margin-bottom: 12px;
    font-size: var(--fs-caption);
    color: var(--v-txtSecondary-base);
}

.booking-type-option {
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
    padding: 14px 16px;
    text-align: left;
    border: 1px solid var(--v-outline-base);
    border-radius: 12px;
    background: var(--v-surface2-base);
    transition: border-color 0.15s;
}

.booking-type-option + .booking-type-option {
    margin-top: 10px;
}

.booking-type-option:hover {
    border-color: var(--v-primary-base);
}

.theme--light .booking-type-option:hover {
    border-color: var(--v-accent-base);
}

.booking-type-name {
    font-size: var(--fs-label);
    font-weight: 700;
    color: var(--v-txtPrimary-base);
}

.booking-type-desc {
    font-size: var(--fs-caption);
    line-height: 1.4;
    color: var(--v-txtSecondary-base);
}
</style>
